import React, {useState} from 'react'
import {Button, Form, Input, Modal} from "antd";
import {updateRelevantPerson} from "../../services/serviceRelevantPerson";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const RelevantEdit = ({record, updater}) => {

    const [form] = Form.useForm()
    const [updateModal, setUpdateModal] = useState(false)
    const [loadings, setLoadings] = useState([])

    const changeModalStatus = () => setUpdateModal(!updateModal)

    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const {
            name,
            surname,
            phone,
            internal,
            title
        } = form.getFieldsValue()

        let requestObj = {
            name: name,
            surname: surname,
            phone: phone,
            title: title,
            internalPhoneCode: internal,
            id: record.id,
            customer: {
                id: record.customerId
            }
        }

        updateRelevantPerson(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                changeModalStatus()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    return(
        <React.Fragment>
            <Button
                type={'link'}
                onClick={changeModalStatus}
            >
                Güncelle
            </Button>
            <Modal
                title={'İlgili Kişi Güncelle'}
                open={updateModal}
                onCancel={changeModalStatus}
                footer={[
                    <Button
                        type={'primary'}
                        onClick={form.submit}
                        loading={loadings[0]}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={changeModalStatus}
                    >
                        Kapat
                    </Button>
                ]}
            >

                <Form
                    form={form}
                    onFinish={handleSubmit}
                    labelAlign={'left'}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                >
                    <Form.Item
                        name={'name'}
                        label={'İlgili Adı'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                        initialValue={record.relName}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'surname'}
                        label={'İlgili Soyadı'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                        initialValue={record.relSurname}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'title'}
                        label={'İlgili Ünvan'}
                        initialValue={record.relTitle}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'phone'}
                        label={'İlgili Telefonu'}
                        rules={[
                            {required:true, message: 'Bu Alan Boş Bırakılamaz'},
                            {pattern: /^\d*$/, message: 'Telefon Alanı Numaralardan Oluşmalıdır'}
                        ]}
                        initialValue={record.relPhone}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'internal'}
                        label={'Dahili'}
                        initialValue={record.relInternal}
                    >
                        <Input />
                    </Form.Item>
                </Form>

            </Modal>
        </React.Fragment>
    )
}
export default RelevantEdit